import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // ✅ for navigation
import HttpApis from "../../services/HttpApis";
import "./style.css";

function CreateProfile() {
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [name, setName] = useState("");
  const [avatars, setAvatars] = useState([]);
  const navigate = useNavigate(); // ✅ initialize navigate

  useEffect(() => {
    const fetchAvatars = async () => {
      try {
        const response = await HttpApis.getAllAvatarImg();
        if (response.data && response.data.data) {
          setAvatars(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching avatars:", error);
      }
    };

    fetchAvatars();
  }, []);

  // ✅ Create profile handler with redirect
  const handleCreateProfile = async () => {
    if (!name || !selectedAvatar) {
      alert("Please enter a name and select an avatar");
      return;
    }

    try {
      const payload = {
        name: name,
        avatar: selectedAvatar,
        language: "english",
        preferences: ""
      };

      await HttpApis.postCreateProfile(payload);

      // ✅ redirect to /profile after success
      navigate("/profile");
    } catch (error) {
      console.error("Error creating profile:", error);
      alert("Failed to create profile. Please try again.");
    }
  };

  return (
    <div className="profile-container">
      <div className="profile-content">
        <h2 className="profile-title">Choose Your Profile</h2>

        <div className="avatar-container">
          {avatars.map((avatar) => (
            <div className="avatar-wrapper" key={avatar.id}>
              <button
                className={`avatar-button ${
                  selectedAvatar === avatar.id ? "selected" : ""
                }`}
                onClick={() => setSelectedAvatar(avatar.id)}
              >
                <img
                  src={avatar.image_url || avatar.avatar_img}
                  alt={avatar.name || "avatar"}
                  className="avatar-image"
                />
              </button>
            </div>
          ))}
        </div>

        <div className="profile-input-container">
          <input
            type="text"
            placeholder="Enter profile name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="profile-input"
          />
        </div>

        <div className="button-container profile-button-spacing">
          <button
            className="profile-button"
            onClick={handleCreateProfile} // ✅ call handler
          >
            submit
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateProfile;
